import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { companyTexts, headMenuTexts } from '../contexts/LangCompany';
import { useLanguage } from '../contexts/LanguageContext';

function Footer() {
  const navigate = useNavigate();
  const { lang } = useLanguage();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <footer style={{
      background: '#222',
      color: '#fff',
      padding: isMobile ? '30px 0 20px 0' : '40px 0 20px 0',
      fontSize: '0.98rem',
      lineHeight: '1.7'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: isMobile ? '0 20px' : '0 40px',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: isMobile ? 'flex-start' : 'space-between',
        alignItems: 'flex-start',
        flexDirection: isMobile ? 'column' : 'row',
        gap: isMobile ? '30px' : '0'
      }}>
        <div>
          <div style={{ fontWeight: 'bold', fontSize: '1.3rem', marginBottom: '12px', letterSpacing: '2px' }}>
            <Link to="/" style={{ color: '#fff', textDecoration: 'none' }}>
              RIMAHR
            </Link>
          </div>
          <div style={{ marginBottom: '8px' }}>
            {companyTexts.Title[lang]}<br />
            {companyTexts.Biznumber[lang]}<br />
            {companyTexts.Telnumber[lang]}<br />
          </div>
          <div>
            {companyTexts.Address[lang]}<br />
          </div>
        </div>
        <div style={{ 
          minWidth: '180px', 
          marginTop: isMobile ? '0' : '12px', 
          display: 'flex', 
          flexDirection: isMobile ? 'row' : 'column', 
          gap: isMobile ? '40px' : '8px',
          flexWrap: 'wrap'
        }}>
          <div>
            <div style={{ 
              display: 'inline-block', 
              verticalAlign: 'top', 
              marginRight: isMobile ? '0' : '32px',
              marginBottom: isMobile ? '20px' : '0'
            }}>
              <div style={{ color: '#fff', fontWeight: 500, marginBottom: '6px' }}>{headMenuTexts.product[lang]}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <span
                  onClick={() => navigate('/product/halcyon')}
                  style={{ color: '#fff', textDecoration: 'none', fontSize: '0.97rem', cursor: 'pointer' }}
                >Halcyon</span>
                <span
                  onClick={() => navigate('/product/primx-zc')}
                  style={{ color: '#fff', textDecoration: 'none', fontSize: '0.97rem', cursor: 'pointer' }}
                >PRIMX ZONECENTRAL</span>
                {/* <span
                  onClick={() => navigate('/product/1kosmos')}
                  style={{ color: '#fff', textDecoration: 'none', fontSize: '0.97rem', cursor: 'pointer' }}
                >1KOSMOS</span> */}
                <span
                  onClick={() => navigate('/product/proofpoint-oit')}
                  style={{ color: '#fff', textDecoration: 'none', fontSize: '0.97rem', cursor: 'pointer' }}
                >Proofpoint OBSERVEIT</span>
                {/* <span
                  onClick={() => navigate('/product/mobileum')}
                  style={{ color: '#fff', textDecoration: 'none', fontSize: '0.97rem', cursor: 'pointer' }}
                >Mobileum</span> */}
              </div>
            </div>
            <div style={{ display: 'inline-block', verticalAlign: 'top', marginRight: '32px' }}>
              <div style={{ color: '#fff', fontWeight: 500, marginBottom: '6px' }}>{headMenuTexts.company[lang]}</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <span
                  onClick={() => navigate('/company/about')}
                  style={{ color: '#fff', textDecoration: 'none', fontSize: '0.97rem', cursor: 'pointer' }}
                >{headMenuTexts.company.about[lang]}</span>
                <span
                  onClick={() => navigate('/company/location')}
                  style={{ color: '#fff', textDecoration: 'none', fontSize: '0.97rem', cursor: 'pointer' }}
                >{headMenuTexts.company.location[lang]}</span>
              </div>
            </div>
            <a
              onClick={() => navigate('/contactuse')}
              style={{ color: '#fff', textDecoration: 'none', marginRight: '18px', fontWeight: 500, cursor: 'pointer' }}
            >{headMenuTexts.contact[lang]}</a>
            <Link to="/privacy" style={{ color: '#aaa', textDecoration: 'underline', fontSize: '0.95rem' }}>{companyTexts.Privacy[lang]}</Link>
          </div>
        </div>
      </div>
      <div style={{
        borderTop: '1px solid #444',
        marginTop: '32px',
        paddingTop: '16px',
        textAlign: 'center',
        color: '#aaa',
        fontSize: '0.93rem'
      }}>
        <span>&copy; 2025 RIMAHR. All rights reserved.</span>
        <a
          href="https://x.com/Rimahrsns"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="X (Twitter)"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            background: '#333',
            color: '#fff',
            textDecoration: 'none',
            transition: 'background 0.2s',
            marginLeft: '12px',
            verticalAlign: 'middle'
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#555'}
          onMouseLeave={e => e.currentTarget.style.background = '#333'}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.259 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
        </a>
        <a
          href="https://blog.naver.com/rimahrblog"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Naver Blog"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            background: '#03C75A',
            color: '#fff',
            textDecoration: 'none',
            transition: 'background 0.2s',
            marginLeft: '8px',
            verticalAlign: 'middle',
            fontWeight: 'bold',
            fontSize: '14px',
            fontFamily: 'sans-serif'
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#02a84a'}
          onMouseLeave={e => e.currentTarget.style.background = '#03C75A'}
        >
          N
        </a>
        <a
          href="https://ideas48097.tistory.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Tistory Blog"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '28px',
            height: '28px',
            borderRadius: '50%',
            background: '#FF5544',
            color: '#fff',
            textDecoration: 'none',
            transition: 'background 0.2s',
            marginLeft: '8px',
            verticalAlign: 'middle',
            fontWeight: 'bold',
            fontSize: '14px',
            fontFamily: 'sans-serif'
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#e04433'}
          onMouseLeave={e => e.currentTarget.style.background = '#FF5544'}
        >
          T
        </a>
      </div>
    </footer>
  );
}

export default Footer;